import { createSelector } from "reselect";
import { selectHavainnotState } from "../../store/selectors";
import { useSelector } from "react-redux";
import { isLoaded, createLoaded, createLoading } from "../../../../sg-core";
import { useAppRoles } from "../../store/selectors/contextSelectors";
import { AuthenticationType } from "./authReducer";
import { apiService } from "../../../store";

export const selectAuthState = createSelector(
    selectHavainnotState,
    (state) => state.authentication,
);

export const selectLoginStatus = createSelector(
    selectAuthState,
    (auth) => auth.authenticationStatus,
);

export const selectToken = createSelector(
    selectAuthState,
    (auth) => auth.token,
);

export const selectRdr = createSelector(
    selectAuthState,
    (auth) => auth.rdr,
);


export const selectLanguage = createSelector(
    selectAuthState,
    (auth) => auth.lang,
);

export const selectReturnHref = createSelector(
    selectAuthState,
    (auth) => auth.returnHref,
);

export const selectLoggedInUserId = createSelector(
    selectAuthState,
    (auth) => auth.loggedInUserId,
);

export const selectLoggedInUser = createSelector(
    selectAuthState,
    (auth) => auth.loggedInUser,
);

export const selectAnonPackage = createSelector(
    selectAuthState,
    (auth) => auth.anonPackage,
);



export const selectUsersAppRoles = createSelector(
    selectAuthState,
    (auth) => auth.appRoles,
);

export const selectLogoutCounter = createSelector(
    selectAuthState,
    (auth) => auth.logoutCounter,
);


export const selectApiService = createSelector(
    selectAuthState,
    (auth) => {
        if (auth.token) { apiService.setToken(auth.token); };
        const anonymousSession = isLoaded(auth.authenticationStatus) && AuthenticationType.AnonToken === auth.authenticationStatus.data;
        return { apiService, anonymousSession }
    },
);



// HOOKS

export const useLoginStatus = () => useSelector(selectLoginStatus);

export const useLoggedInUser = () => useSelector(selectLoggedInUser);

export const useAnonPackage = () => useSelector(selectAnonPackage);

export const useLoggedInUserRoles = () => {
    const user = useLoggedInUser();
    if (!user) {
        return [];
    }
    return user.roles;
};

export const useLoggedInUserRoleRefrences = () => {
    const user = useLoggedInUser()
    return user ? (user.roles || []).map(({ reference }: any) => reference) : []
};

export const useUsersAppRoles = () => useSelector(selectUsersAppRoles);

export const useUsersAppRoleIdList = () => {
    const usersRoles = useSelector(selectUsersAppRoles);
    const appRoles = useAppRoles();

    if (isLoaded(usersRoles) && isLoaded(appRoles)) {
        return createLoaded(
            usersRoles.data.map((refrence) => {
                let role = appRoles.data.find((r) => r.reference === refrence);
                return role?.id;
            })
        )
    }

    return createLoading()
};



export const useAuthentication = () => {
    const token = useSelector(selectToken);
    const loginStatus = useLoginStatus();
    const loggedIn = isLoaded(loginStatus);

    return {
        token,
        loginStatus,
        loggedIn,
        anonymousSession: isLoaded(loginStatus) && loginStatus.data === AuthenticationType.AnonToken
    }
}
